import { Box, Checkbox, Typography, styled } from "@mui/material";
import { TreeItem, treeItemClasses } from "@mui/x-tree-view";
const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
  [`& .${treeItemClasses.content}`]: {
    display: "flex",
    alignItems: "center",
    height: "40px",
    // border: "1px solid #ffffff",
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      left: -10,
      bottom: "50%",
      transform: "translateY(50%)",
      width: 10,
      // borderBottom: `2px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
  },
  [`& .${treeItemClasses.groupTransition}`]: {
    marginTop: -8,
    marginLeft: 13,
    paddingLeft: 8,
    // borderLeft: `2px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    position: "relative",
  },
  [`& .${treeItemClasses.root}`]: {
    "&:last-child .${treeItemClasses.groupTransition}": {
      borderLeft: "none",
    },
  },
  [`& .singleChild .${treeItemClasses.groupTransition}`]: {
    "&:before": {
      content: '""',
      position: "absolute",
      left: -8,
      top: -12,
      height: 12,
    },
  },
}));

const RecursiveListItem = ({
  edit,
  item,
  searchTerm,
  partyGroupId,
  onCheck,
  setCustomerGroup,
}) => {
  const hasChildren = item.children && item.children.length > 0;

  const label = item.label.toLowerCase();
  const matchesSearch = label?.includes(searchTerm?.toLowerCase());
  if (searchTerm && !matchesSearch && !hasChildren) {
    return null;
  }
  const handleCheckItems = (item) => {
    onCheck(item);
  };
  return (
    <CustomTreeItem
      itemId={item?.value}
      itemID={item?.value}
      key={item?.value}
      endOfDashedLine={item?.children?.length}
      sx={{
        ".MuiTreeItem-content": {
          gap: "0px",
          padding: "0px 4px",
          height: "32px",
        },
      }}
      label={
        <Box key={item?.value} sx={{ display: "flex", alignItems: "center" }}>
          <Checkbox
            id="test"
            sx={{
              padding: "4px",
              color: "rgba(0, 0, 0, 0.3)",
              ".MuiSvgIcon-root": {
                fontSize: "20px",
              },
            }}
            checked={item.value == partyGroupId}
            onClick={(event) => {
              event.stopPropagation();
              setCustomerGroup(item.value);
              handleCheckItems(item);
            }}
          />
          <Typography
            key={item?.value}
            sx={{
              fontSize: "13px",
              width: "150px",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitLineClamp: 2, // Limits to 2 lines
              // lineHeight: "1.5", // Adjust based on typography line height
              maxHeight: "3em",
              fontWeight: edit && edit == item.value[1] ? "600" : "400",
              color: edit && edit == item.value[1] ? "#cccccc" : "",
            }}
            onClick={(e) => {
              setCustomerGroup(item.value);
              handleCheckItems(item);
            }}
          >
            {item.label}
          </Typography>
        </Box>
      }
    >
      {item?.children.length === 0
        ? null
        : item?.children?.map((child) => (
            <RecursiveListItem
              key={item?.value}
              item={child}
              searchTerm={searchTerm}
              setCustomerGroup={setCustomerGroup}
              partyGroupId={partyGroupId}
              onCheck={onCheck}
            />
          ))}
    </CustomTreeItem>
  );
};

export default RecursiveListItem;
